<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading" 
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Freight Quotation Form</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="d-block text-center">
              <!-- <md-layout md-gutter>
                <md-layout md-flex="10">
                </md-layout>
                <md-layout md-flex="30"></md-layout>
                <md-layout md-flex="40">
                  <h2 style="text-align:center">Freight Quotation</h2>
                </md-layout>
                <md-layout md-flex="10"></md-layout>
                <md-button
                  class="md-fab md-primary-red"
                  v-if="mainModal.mainffId!='' && mainModal.ffStatusManager!='1' &&  mainModal.ffClientStatus!='2'"
                  @click="openPop"
                >
                  <md-icon>contact_mail</md-icon>
                </md-button>
              </md-layout>-->
              <div>
                <b-collapse id="collapseFFMain" v-model="collapseFFMainVisible">
                  <div class="box-body">
                    <div class="box-header">
                      <!-- v-if="hideButtn==false" -->
                      <!-- <md-button
                          @click="openFF"
                          class="md-raised md-primary md-button-color md-theme-default back heght-1px pull-right"
                      >New FF Quotation</md-button>-->
                    </div>
                    <div class="table-responsive tableMain">
                      <table id="ff" class="table mobile-table table-bordered">
                        <thead>
                          <tr>
                            <th>Sr no</th>
                            <th>FF Quotation No.</th>

                            <th>Approval Status</th>

                            <th>Action</th>
                            <th>Print</th>

                            <!-- <th>Client Name</th> -->
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item1, index) in tableMainData" :key="index">
                            <td>{{ index + 1 }}</td>

                            <td :style="index == 0 ? 'color:green' : 'color:red'">
                              <b>Quotation No. :</b>
                              {{ item1.mainFFSeries }}
                              <br />
                              <b>Validity Till :</b>
                              {{ item1.quotationTill == "1" ? "Handover" : "Sailing" }}
                              <br />
                              <b>Validity Date :</b>
                              {{ item1.ffvalidityDate | moment }}
                              <br />
                              <span class="error">{{
                                item1.ffExpireStatus == 1 ? " (Expired)" : ""
                              }}</span>
                              <br />
                              <b-button
                                v-if="collapseFFChildVisible == false"
                                @click="getMainFFId(item1.mainffId, 'FF')"
                                variant="outline-dark"
                                size="sm"
                                >Show Quote</b-button
                              >
                            </td>
                            <td>
                              <b>Manager Approval :</b>
                              {{
                                item1.ffStatusManager == "0"
                                  ? "Pending"
                                  : item1.ffStatusManager == "1"
                                  ? "Approved"
                                  : "Rejected"
                              }}
                              <br />
                              <b>Client Approval :</b>
                              {{
                                item1.ffClientStatus == "0"
                                  ? "Pending"
                                  : item1.ffClientStatus == "1"
                                  ? "Approved"
                                  : "Rejected"
                              }}
                              <br />
                              <br />
                              <span v-if="item1.ffQuoteRejectCount != '0'" class="error"
                                >Note : Quote Rejected
                                {{ item1.ffQuoteRejectCount }} Times By Client.</span
                              >
                            </td>
                            <td
                              v-if="
                                index == '0' &&
                                item1.ffClientStatus != '2' &&
                                item1.ffClientStatus != '1'
                              "
                            >
                              <b
                                v-if="
                                  item1.ffStatusManager != '1' &&
                                  item1.sendHODApproveFF == '1'
                                "
                                >Sent For Approval
                                <br />
                              </b>
                              <!-- <b
                                v-else-if="item1.ffStatusManager=='1' && item1.sendToEnquiryFF=='0'"
                                class="showMoreData"
                              >Send To Enquiry Team
                                <br>
                              
                              </b>-->
                              <b
                                v-else-if="
                                  item1.ffStatusManager == '1' &&
                                  item1.sendToEnquiryFF == '1'
                                "
                                >Sent to Enquiry
                                <br />
                              </b>
                              <b v-else
                                >N/A
                                <br />
                              </b>
                            </td>
                            <td v-else>
                              <b>
                                {{
                                  item1.ffClientStatus == "2" && index == 0
                                    ? "Client Rejected"
                                    : item1.ffClientStatus == "1" && index == 0
                                    ? "Client Approved"
                                    : "N/A"
                                }}
                                <br />
                              </b>
                            </td>
                            <td>
                              <span v-if="item1.MainEnquiryQuotationFFCreated">{{ item1.MainEnquiryQuotationFFCreated }}</span><br/>
                              <span v-if="item1.MainEnquiryQuotationFFUpdated">{{ item1.MainEnquiryQuotationFFUpdated }}</span><br/>
                              <span v-if="item1.MainEnquiryQuotationFFApprovedBy">{{ item1.MainEnquiryQuotationFFApprovedBy }}</span><br/>
                              <md-button
                                v-if="
                                  item1.ffQuotationPdf != '' &&
                                  item1.ffQuotationPdf != null
                                "
                                class="md-icon-button md-raised md-dense"
                                @click="Print(item1.ffQuotationPdf)"
                              >
                                <md-icon>print</md-icon>
                              </md-button>
                              <b v-else>Pdf Not Generated</b>
                              <div v-if="!isHidden">
                                <date-picker
                                  style="margin-top: 8px"
                                  lang="en"
                                  :format="selectDateFormat"
                                  id="validityDate"
                                  name="validityDate"
                                  :not-before="min"
                                  :not-after="max"
                                  v-model="item1.ffvalidityDate"
                                ></date-picker>
                                <!-- hide hideMe  -->
                                <span class="error" v-if="!item1.ffvalidityDate">{{
                                  errorModal.ffvalidityDate
                                }}</span>
                                <!-- hide hideMe  -->

                                <b-button
                                  class="smbutnWidth"
                                  style="margin-top: 8px"
                                  variant="primary"
                                  size="sm"
                                  id="updateValidityDate"
                                  @click="
                                    updateValidityDate(
                                      item1.ffvalidityDate,
                                      item1.mainffId,
                                      this.mainFFtableIdForFF,
                                      'FF',
                                      item1.quotationTill,
                                      (prevalidityDate = item1.ffvalidityDate)
                                    )
                                  "
                                  >Update</b-button
                                >
                              </div>

                              <b-button
                                v-if="item1.ffExpireStatus == 1"
                                class="smbutnWidth"
                                style="margin-top: 8px"
                                variant="primary"
                                size="sm"
                                id="QutationValidityhide"
                                @click="
                                  QutationValidityhide(item1.ffvalidityDate, isHidden)
                                "
                                >Qutation Extends</b-button
                              >
                              <br /><span id="QutationValidityhide_err"></span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-collapse>
              </div>
              <div>
                <b-collapse id="collapseFFChild" v-model="collapseFFChildVisible">
                  <div>
                    <b-card class="gutr">
                      <b-row>
                        <b-col md="3">
                          <md-layout md-flex="20">
                            <label>Quotation Validity Date</label>
                            <!-- <date-picker
                              :disabled="mainFFtableIdForFF ? true : false"
                              lang="en"
                              :format="selectDateFormat"
                              id="validityDate"
                              name="validityDate"
                              :min="calculateMinDate()"
                              :max="calculateMaxDate()"
                              v-model="mainModal.ffvalidityDate"
                            ></date-picker> -->
                            <b-form-input
                            :disabled="mainFFtableIdForFF ? true : false"
                              :formatter="capitalizeAll"
                              v-model="mainModal.ffvalidityDate"
                              type="date"
                              placeholder="Enter Billing Start Date"
                              :min="calculateMinDate()"
                              :max="calculateMaxDate()"
                            ></b-form-input>
                          </md-layout>
                        </b-col>
                        <b-col md="3" v-if="shipmentType == 1">
                          <md-layout md-flex="25" v-if="shipmentType == 1">
                            <label>Quotation Validity Till</label>
                            <model-list-select
                              :list="qTillList"
                              v-model="mainModal.quotationTill"
                              option-value="qV"
                              option-text="qT"
                              placeholder="Select"
                            ></model-list-select>
                          </md-layout>
                        </b-col>
                        <b-col md="3">
                          <md-layout md-flex="100">
                            <label for="quoRate">Quotation Remarks</label>
                            <b-form-input
                              :formatter="capitalizeAll"
                              id="quoRate"
                              name="quoRate"
                              v-model="mainModal.quotation_remark"
                            ></b-form-input>
                          </md-layout>
                        </b-col>
                        <b-col
                          md="3"
                          v-if="
                            mainModal.sendHODApproveFF == '1' &&
                            this.$sessionsStorage.get('userLevel') == '1'
                          "
                        >
                          <md-layout md-flex="25">
                            <label for="transportType">Manager Approval</label>
                            <model-list-select
                              :isDisabled="mainModal.ffClientStatus == '1' ? true : false"
                              :list="statusList"
                              v-model="mainModal.ffStatusManager"
                              option-value="statusV"
                              option-text="statusT"
                              placeholder="Select Status"
                            ></model-list-select>
                          </md-layout>
                        </b-col>
                      </b-row>
                      <b-row class="mt-4">
                        <b-col md="12">
                          <div
                            v-if="
                              mainModal.sendHODApproveFF == '1' &&
                              this.$sessionsStorage.get('userLevel') == '1'
                            "
                          >
                            <!--  -->
                            <b-button
                              class="smbutnWidth"
                              variant="primary"
                              size="sm"
                              id="addButtonLoaderM"
                              @click="addGenerateQuotation('5')"
                              >Update</b-button
                            >
                          </div>
                          <md-spinner
                            md-indeterminate
                            id="loaderM"
                            style="display: none"
                          ></md-spinner>
                        </b-col>
                      </b-row>
                      <!-- <md-layout md-gutter class="align-items-end">
                        <md-layout md-flex="20">
                          <label>Quotation Validity Date</label>
                          <date-picker
                            :disabled="mainFFtableIdForFF?true:false"
                            lang="en"
                            :format="selectDateFormat"
                            id="validityDate"
                            name="validityDate"
                            v-model="mainModal.ffvalidityDate"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25" v-if="shipmentType == 1">
                          <label>Quotation Validity Till</label>
                          <model-list-select
                            :list="qTillList"
                            v-model="mainModal.quotationTill"
                            option-value="qV"
                            option-text="qT"
                            placeholder="Select"
                          ></model-list-select>
                        </md-layout>
                         <md-layout md-flex="5"></md-layout>
                         <md-layout
                              md-flex="20"
                            >
                              <md-layout md-flex="100">
                                <label for="quoRate">Quotation Remarks</label>

                                <b-form-input
                                  :formatter="capitalizeAll"
                                  id="quoRate"
                                  name="quoRate"
                                  v-model="mainModal.quotation_remark"
                                ></b-form-input>
                              </md-layout>
                            </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout
                          md-flex="25"
                          v-if="
                            mainModal.sendHODApproveFF == '1' &&
                            this.$sessionsStorage.get('userLevel') == '1'
                          "
                        >
                          <label for="transportType">Manager Approval</label>
                          <model-list-select
                            :isDisabled="mainModal.ffClientStatus=='1'?true:false"
                            :list="statusList"
                            v-model="mainModal.ffStatusManager"
                            option-value="statusV"
                            option-text="statusT"
                            placeholder="Select Status"
                          ></model-list-select>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="10">
                        <div
                         
                          v-if="
                            mainModal.sendHODApproveFF == '1' &&
                            this.$sessionsStorage.get('userLevel') == '1'
                          "
                        >
                          <b-button
                            class="smbutnWidth"
                            variant="primary"
                            size="sm"
                            id="addButtonLoaderM"
                            @click="addGenerateQuotation('5')"
                            >Update</b-button
                          >
                        </div>
                        </md-layout>
                       
                        <md-spinner
                          md-indeterminate
                          id="loaderM"
                          style="display: none"
                        ></md-spinner>
                      </md-layout> -->
                    </b-card>
                  </div>
                  <b-navbar
                    variant="light"
                    type="light"
                    style="background: white !important"
                    class="gutr ml-3"
                  >
                    <b-navbar-nav>
                      <div v-if="ffShipArry.length > 0">
                        <b-button-group
                          v-if="
                            mainModal.ffStatusManager != '1' &&
                            mainModal.ffClientStatus != '1'
                          "
                        >
                          <b-button
                            v-if="visibleMFF == true"
                            size="sm"
                            class="pull-left"
                            variant="outline-dark"
                            @click="visibleMFFFalse"
                            >Close</b-button
                          >
                          <b-button
                            v-else
                            size="sm"
                            class="pull-left"
                            variant="outline-dark"
                            @click="visibleMFFTrue"
                            >New Entry</b-button
                          >
                        </b-button-group>
                      </div>
                    </b-navbar-nav>
                    <b-navbar-nav class="ml-auto">
                      <div v-if="ffShipArry.length > 0">
                        <b-button-group>
                          <b-button
                            v-if="
                              mainModal.mainffId != '' &&
                              mainModal.ffStatusManager != '1' &&
                              mainModal.ffClientStatus != '1' &&
                              mainModal.sendHODApproveFF != '1'
                            "
                            size="sm"
                            class="pull-right"
                            variant="outline-dark"
                            @click="openPop"
                            >Send For Aproval
                            <md-icon icon="envelope">email</md-icon>
                          </b-button>
                        </b-button-group>
                      </div>
                    </b-navbar-nav>
                  </b-navbar>
                  <div>
                    <div class="gutr" v-if="ffShipArry.length > 0">
                      <!-- <div class="box-header">
                      <h5 class="box-title">
                        <u>Shipping Line Details</u>
                      </h5>
                
                      </div>-->
                      <div class="table-responsive tableMain">
                        <table class="table table-bordered">
                          <thead>
                            <tr>
                              <!-- <th>Sr no</th> -->
                              <th v-if="shipmentType == 1 && fclOrlcl == 'lcl'">
                                Co-Loader
                              </th>
                              <th v-else-if="shipmentType == 1">Shipping Line</th>
                              <th v-else>Airline Name</th>
                              <th>Client Approval</th>
                              <th>Action</th>

                              <!-- <th>Client Name</th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item1, index) in ffShipArry" :key="index">
                              <!-- <td>{{index+1}}</td> -->
                              <td v-if="shipmentType == 1 && fclOrlcl == 'lcl'">
                                {{ item1.coLoaderName }}
                              </td>
                              <td v-else-if="shipmentType == 1">
                                {{ item1.shippingLine }}
                              </td>
                              <td v-else>{{ item1.airlineName }}</td>

                              <td>
                                {{
                                  item1.ffClientStatus == ""
                                    ? "Pending"
                                    : item1.ffClientStatus == "1"
                                    ? "Approved"
                                    : "-"
                                }}
                              </td>

                              <!-- <td>{{item1.clientName}}</td> -->
                              <td>
                                <md-button
                                  class="md-icon-button md-raised md-dense"
                                  :disabled="item1.ffClientStatus == '2'"
                                  @click="editShip(item1)"
                                >
                                  <md-icon>edit</md-icon>
                                </md-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- /.box-body -->
                    </div>
                    <!-- <b-button
                      :class="visibleMFF ? null : 'collapsed'"
                     
                    >Toggle Collapse</b-button>-->

                    <div>
                      <b-collapse id="collapseMiddle" v-model="visibleMFF" class="mt-2">
                        <div>
                          <div>
                            <div
                              v-if="
                                ffShipArry.length < 3 || shipModal.ffShippingWiseId != ''
                              "
                            >
                              <div>
                                <b-card class="gutr">
                                  <md-layout
                                    md-flex="15"
                                    class="justify-content-end"
                                    v-if="shipModal.ffShippingWiseId != ''"
                                  >
                                    <div>
                                      <b-button
                                        size="sm"
                                        variant="outline-dark"
                                        @click="clearShip"
                                        :disbaled="ffShipArry.length < 3 ? false : true"
                                        >New
                                        {{
                                          shipmentType == "1"
                                            ? " Shipping Line"
                                            : " Airline"
                                        }}</b-button
                                      >
                                    </div>
                                  </md-layout>
                                  <md-layout md-gutter v-if="shipmentType == '2'">
                                    <md-layout md-flex="80">
                                      <span class="error">
                                        JobType :
                                        <b>{{ enquiryArry[0].jobType }}</b>
                                      </span>
                                    </md-layout>
                                  </md-layout>
                                  <md-layout
                                    md-gutter
                                    v-if="
                                      shipmentType == '1' ||
                                      shipmentType == 'Sea_Shipment'
                                    "
                                  >
                                    <md-layout md-flex="80">
                                      <span class="error">
                                        Note : Prefered Shipping Line
                                        <b>{{ enquiryArry[0].shippingLine }}</b>
                                      </span>
                                    </md-layout>
                                  </md-layout>
                                  <md-layout
                                    md-gutter
                                    v-if="
                                      shipmentType == 1 &&
                                      enquiryArry[0].containerInfo == 'lcl'
                                    "
                                  >
                                    <md-layout md-flex="10">
                                      <label>No.of Package</label>
                                      <b-form-input
                                        :formatter="capitalizeAll"
                                        disabled
                                        id="transitTime"
                                        name="transitTime"
                                        v-model="noOfPkg"
                                      ></b-form-input>
                                    </md-layout>
                                    <!-- <md-layout md-flex="5"></md-layout>
                                    <md-layout md-flex="10">
                                      <label>Dimension</label>
                                      <b-form-input :formatter="capitalizeAll"
                                        disabled
                                        id="transitTime"
                                        name="transitTime"
                                        v-model="dimension"
                                      ></b-form-input>
                                    </md-layout>-->
                                    <md-layout md-flex="5"></md-layout>
                                    <md-layout md-flex="15">
                                      <label>Vol.Wgt(In CBM)</label>
                                      <b-form-input
                                        :formatter="capitalizeAll"
                                        disabled
                                        id="transitTime"
                                        name="transitTime"
                                        v-model="volWgt"
                                      ></b-form-input>
                                    </md-layout>
                                    <md-layout md-flex="5"></md-layout>
                                    <md-layout md-flex="15">
                                      <label>Gross Wgt.(In Kg)</label>
                                      <b-form-input
                                        :formatter="capitalizeAll"
                                        disabled
                                        id="transitTime"
                                        name="transitTime"
                                        v-model="grsWgt"
                                      ></b-form-input>
                                    </md-layout>
                                    <md-layout md-flex="5"></md-layout>
                                    <md-layout md-flex="15">
                                      <label>Net Wgt.(In Kg)</label>
                                      <b-form-input
                                        :formatter="capitalizeAll"
                                        disabled
                                        id="transitTime"
                                        name="transitTime"
                                        v-model="netWgt"
                                      ></b-form-input>
                                    </md-layout>
                                    <!-- <md-layout md-flex="5"></md-layout>
                                    <md-layout md-flex="45">
                                      <label>Remarks</label>
                                      <b-form-textarea :formatter="capitalizeAll"
                                        id="transitTime"
                                        name="transitTime"
                                        v-model="remarks"
                                      ></b-form-textarea>
                                    </md-layout> -->
                                  </md-layout>
                                  <md-layout md-gutter>
                                    <md-layout md-flex="50" class="pr-2 pl-2">
                                      <label for="shippingId"
                                        >{{
                                          shipmentType == "1" && fclOrlcl == "lcl"
                                            ? " Co-Loader "
                                            : shipmentType == "1"
                                            ? "Shipping Line"
                                            : "Airline"
                                        }}
                                        Name *</label
                                      >
                                      <model-list-select
                                        :isDisabled="shipModal.ffShippingWiseId != ''"
                                        :list="
                                          shipmentType == '1' && fclOrlcl == 'lcl'
                                            ? coloaderData
                                            : shipmentType == '1'
                                            ? shippingList
                                            : airLineData
                                        "
                                        v-model="shipModal.shippingId"
                                        :option-value="
                                          shipmentType == '1' && fclOrlcl == 'lcl'
                                            ? 'agntColoaderId'
                                            : shipmentType == '1'
                                            ? 'shippingId'
                                            : 'airlineId'
                                        "
                                        :option-text="
                                          shipmentType == '1' && fclOrlcl == 'lcl'
                                            ? 'coLoaderName'
                                            : shipmentType == '1'
                                            ? 'shippingLine'
                                            : 'airlineName'
                                        "
                                        :placeholder="
                                          shipmentType == '1' && fclOrlcl == 'lcl'
                                            ? 'Select Co-Loader'
                                            : shipmentType == '1'
                                            ? 'Select Shipping Line'
                                            : 'Select Airline'
                                        "
                                      ></model-list-select>
                                    </md-layout>
                                    <!-- <md-layout md-flex="5"></md-layout> -->
                                    <md-layout md-flex="50" class="pr-2 pl-2">
                                      <label>Transit Time (No.of Days)</label>
                                      <b-form-input
                                        :formatter="capitalizeAll"
                                        id="transitTime"
                                        name="transitTime"
                                        type="number"
                                        v-model="shipModal.transitTime"
                                      ></b-form-input>
                                      <!-- <date-picker
                                      placeholder="Select Time"
                                      lang="en"
                                      name="transitTime"
                                      id="transitTime"
                                      type="time"
                                      format="hh:mm a"
                
                                      ></date-picker>-->
                                    </md-layout>
                                    <md-layout
                                      md-flex="50"
                                      class="pr-2 pl-2"
                                      v-if="ffModal.ffQId == ''"
                                    >
                                      <label for="transportType">Particulars *</label>
                                      <model-list-select 
                                      :list="$store.getters['common/getAllLedgerList']" 
                                      v-model="ffModal.ledgerId"
                                      @input="getPartiName"
                                      option-value="ledgerId" 
                                      option-text="ledger" 
                                      placeholder="Select Particular">
                                      </model-list-select>
                                      <!-- <model-list-select
                                        @input="getPartiName"
                                        :list="ledgerData"
                                        v-model="ffModal.ledgerId"
                                        option-value="ledgerId"
                                        option-text="ledger"
                                        placeholder="Select Particulars"
                                      ></model-list-select> -->
                                      <span class="error" v-if="!ffModal.ledgerId">{{
                                        blankffStatusError
                                      }}</span>
                                    </md-layout>
                                    <md-layout md-flex="50" class="pr-2 pl-2" v-else>
                                      <label for="transportType">Particulars</label>
                                      <model-list-select
                                        isDisabled
                                        :list="ledgerData"
                                        v-model="ffModal.ffType"
                                        option-value="ledger"
                                        option-text="ledger"
                                        placeholder="Select Type"
                                      ></model-list-select>
                                    </md-layout>
                                  </md-layout>
                                  <md-layout md-gutter v-if="shipmentType == '1'">
                                    <md-layout md-flex="50" class="pr-2 pl-2">
                                      <label for="transportType">Container Type *</label>
                                      <model-list-select
                                        :list="containerTypeList"
                                        v-model="ffModal.containerTypeId"
                                        option-value="containerTypeId"
                                        option-text="containerType"
                                        placeholder="Select Type"
                                      ></model-list-select>
                                      <span
                                        class="error"
                                        v-if="!ffModal.containerTypeId"
                                        >{{ blankConTypeError }}</span
                                      >
                                    </md-layout>
                                    <!-- </md-layout>

                                  <md-layout md-gutter> -->
                                  </md-layout>
                                  <md-layout md-gutter class="labelMargtop">
                                    <md-layout md-flex="40" class="pr-2 pl-2">
                                      <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="particularStatus"
                                        name="checkbox-1"
                                        value="1"
                                        unchecked-value="0"
                                        >Charges As Per Receipt</b-form-checkbox
                                      >
                                    </md-layout>
                                  </md-layout>

                                  <md-layout md-gutter v-if="particularStatus == '0'">
                                    <md-layout md-flex="20" class="pr-2 pl-2">
                                      <md-layout md-flex="100">
                                        <label for="buyingRate">Buying Rate *</label>

                                        <b-form-input
                                          :formatter="capitalizeAll"
                                          id="buyingRate"
                                          name="buyingRate"
                                          type="number"
                                          v-model="ffModal.buyingRate"
                                        ></b-form-input>
                                        <span class="error" v-if="!ffModal.buyingRate">{{
                                          blankbuyinError
                                        }}</span>
                                      </md-layout>
                                    </md-layout>
                                    <!-- <md-layout md-flex="5"></md-layout> -->

                                    <md-layout md-flex="20" class="pr-2 pl-2">
                                      <md-layout md-flex="100">
                                        <label for="sellingRate">Selling Rate *</label>

                                        <b-form-input
                                          :formatter="capitalizeAll"
                                          id="sellingRate"
                                          name="sellingRate"
                                          type="number"
                                          v-model="ffModal.ffSellingRate"
                                        ></b-form-input>
                                        <span
                                          class="error"
                                          v-if="!ffModal.ffSellingRate"
                                          >{{ blankSellingError }}</span
                                        >
                                      </md-layout>
                                    </md-layout>
                                    <!-- <md-layout md-flex="5"></md-layout> -->

                                    <md-layout md-flex="20" class="pr-2 pl-2">
                                      <label for="transportType">Currency *</label>
                                      <model-list-select
                                        :list="currencyList"
                                        v-model="ffModal.currency"
                                        option-value="currencyV"
                                        option-text="currencyT"
                                        placeholder="Select"
                                      ></model-list-select>
                                      <span class="error" v-if="!ffModal.currency">{{
                                        blankcurrencyError
                                      }}</span>
                                    </md-layout>
                                    <!-- <md-layout md-flex="5"></md-layout> -->

                                    <md-layout
                                      md-flex="20"
                                      class="pr-2 pl-2"
                                      v-if="particularStatus == '0'"
                                    >
                                      <label for="transportType">Units *</label>
                                      <model-list-select
                                        :list="unitList"
                                        v-model="ffModal.unit"
                                        option-value="unitId"
                                        option-text="unitName"
                                        placeholder="Select"
                                      ></model-list-select>
                                      <!-- <span
                                      class="error"
                                      v-if="!tptTableModal.currency"
                                      >{{blankcurrencyError}}</span>-->
                                    </md-layout>
                                    <!-- <md-layout md-flex="5"></md-layout> -->
                                    <md-layout md-flex="20" class="pr-2 pl-2">
                                      <label for="transportType">Terms</label>
                                      <model-list-select
                                        :list="termList"
                                        v-model="ffModal.terms"
                                        option-value="tV"
                                        option-text="tT"
                                        placeholder="Select"
                                      ></model-list-select>
                                      <!-- <span
                                      class="error"
                                      v-if="!tptTableModal.currency"
                                      >{{blankcurrencyError}}</span>-->
                                    </md-layout>
                                    <md-layout md-flex="100">
                                      <label for="sellingRate">Special Remarks</label>

                                      <b-form-textarea
                                        :formatter="capitalizeAll"
                                        id="sellingRate"
                                        name="sellingRate"
                                        v-model="ffModal.line_wise_remark"
                                      ></b-form-textarea>
                                    </md-layout>
                                  </md-layout>
                                  <!-- <md-layout md-gutter class="gutr">
                                    
                                  </md-layout> -->

                                  <md-layout
                                    md-gutter
                                    class="justify-content-center mt-4"
                                  >
                                    <b-button
                                      :disabled="
                                        $sessionsStorage.get('designation') == 'Admin' &&
                                        $sessionsStorage.get('nameUser') == 'Bhavneesh'
                                          ? false
                                          : mainModal.sendHODApproveFF == '1'
                                          ? true
                                          : false
                                      "
                                      class="smbutnWidth"
                                      variant="primary"
                                      id="addButtonLoader1"
                                      @click="addGenerateQuotation('2')"
                                      >{{
                                        ffModal.ffQId == "" ? "Add" : "Update"
                                      }}</b-button
                                    >
                                    <md-spinner
                                      md-indeterminate
                                      id="loader1"
                                      style="display: none"
                                    ></md-spinner>

                                    <b-col lg="12">
                                      <span
                                        class="error pull-right"
                                        v-if="ffModal.MainEnquiryQuotationFFCreated"
                                      >
                                        <b>
                                          {{ ffModal.MainEnquiryQuotationFFCreated }}</b
                                        >
                                      </span>
                                    </b-col>

                                    <b-col lg="12">
                                      <span
                                        class="error pull-right"
                                        v-if="ffModal.MainEnquiryQuotationFFUpdated"
                                      >
                                        <b>
                                          {{ ffModal.MainEnquiryQuotationFFUpdated }}</b
                                        >
                                      </span>
                                    </b-col>

                                    <!-- <b-col lg="12"> {{ ffModal }} </b-col> -->
                                  </md-layout>
                                </b-card>
                              </div>
                            </div>
                          </div>
                        </div>
                      </b-collapse>
                    </div>

                    <!-- {{ tempffTableArry }}
                    {{shipModal.shippingId}} -->
                    <div class="box-body gutr" v-if="tempffTableArry.length > 0">
                      <div class="table-responsive tableMain">
                        <table id="ff" class="table table-bordered">
                          <thead>
                            <tr>
                              <th>Sr no</th>
                              <th v-if="shipmentType == 1 && fclOrlcl == 'lcl'">
                                Co-Loader
                              </th>
                              <th v-else-if="shipmentType == 1">Shipping Line</th>
                              <th v-else>Airline Name</th>
                              <th v-if="shipmentType == '1'">Container Type</th>
                              <th>Particulars</th>

                              <th>Buying Rate</th>
                              <th>Selling Rate</th>
                              <th>Unit</th>
                              <th>Special Remarks</th>
                              <th v-if="shipModal.shippingId != ''">Action</th>
                              <th v-if="shipModal.shippingId != ''">Delete</th>

                              <!-- <th>Client Name</th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item1, index) in shipModal.shippingId == '' ? tempffTableArry : ffTableArry"
                              :key="index"
                            >
                              <td>{{ index + 1 }}</td>
                              <td v-if="shipmentType == '1' && fclOrlcl == 'lcl'">
                                {{ item1.coLoaderName }}
                              </td>
                              <td v-else-if="shipmentType == '1'">
                                {{ item1.shippingLine }}
                              </td>
                              <td v-else>{{ item1.airlineName }}</td>
                              <td v-if="shipmentType == '1'">
                                {{ item1.containerType }}
                              </td>
                              <td>{{ item1.ffType }}</td>

                              <td>{{ item1.buyingRate }} {{ item1.currency }}</td>
                              <td>{{ item1.ffSellingRate }} {{ item1.currency }}</td>
                              <td>
                                {{ item1.unitName ? item1.unitName : "NA" }}
                              </td>
                              <td>
                                {{
                                  item1.line_wise_remark ? item1.line_wise_remark : "NA"
                                }}
                              </td>
                              <!-- <td>{{item1.clientName}}</td> -->
                              <td v-if="shipModal.shippingId != ''">
                                <md-button
                                  class="md-icon-button md-raised md-dense"
                                  :disabled="item1.ffClientStatus == '2'"
                                  @click="editFF(item1, index)"
                                >
                                  <md-icon>edit</md-icon>
                                </md-button>
                              </td>
                              <td v-if="shipModal.shippingId != ''">
                                <md-button
                                  class="md-icon-button md-raised md-dense"
                                  @click="deleteTPT(item1)"
                                >
                                  <md-icon>delete</md-icon>
                                </md-button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <!-- /.box-body -->
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopAlready"
    ></md-dialog-confirm>
    <!-- <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>-->
    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMailAfter"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import { ModelListSelect } from "vue-search-select";

import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus,getConsoleBooking } from "../../helper/collection";
import ClientUserService from "../../services/ClientUserService.js";


export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllLedgerList",
      JSON.stringify({
        itemCode: "LedgerList",
        JobType:this.$route.query.JobType,
        ShipmentType:this.$route.query.ShipmentType,
        ModuleType:this.$route.query.ModuleType,
        isLedgerActive:'1',
      })
    );
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewConsoBooking");
      this.getData();
      this.getBookingList();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      ConsoleBookingList:[],
      errorModal: {
        ffvalidityDate: "",
      },
      arrayErrorModal: {
        ffvalidityDate: "Select Date",
      },
      prevalidityDate: "",
      isHidden: true,
      max: "",
      min: "",
      selectDateFormat,
      dimension: "",
      volWgt: "",
      grsWgt: "",
      netWgt: "",
      noOfPkg: "",
      remarks: "",
      termList: [
        {
          tV: "Collect",
          tT: "Collect",
        },
        {
          tV: "Prepaid",
          tT: "Prepaid",
        },
      ],
      unitList: [],
      newData: {
        mainffId: "",
        mainEnquiryId: "",
        mainFFSeries: "",
        ffQuotationPdf: "",
      },
      collapseFFMainVisible: false,

      collapseFFChildVisible: false,
      visibleMFF: false,
      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel",
      },
      vertical: "bottom",
      horizontal: "center",
      duration: 1700,
      snackbarData: "",
      blankConTypeError: "",
      blankbuyinError: "",
      blankSellingError: "",
      blankcurrencyError: "",
      blankffStatusError: "",
      particularStatus: "0",
      isLoading: false,
      docURL: URL_BASE_DOC,
      openTPTDiv: false,
      openFFDiv: false,
      openCCDiv: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      shipmentType: "",
      fclOrlcl: "",
      tptModal: {
        tptQId: "",
        mainEnquiryId: "",
        enquiryClientId: "",
        driverExp: "",
        travelDur: "",
        distance: "",
        toll: "",
        mileage: "",
        dieselRate: "",
        margin: "",
        baseCost: "",
        quotRate: "",
        tptStatus: "",
        tptClientStatus: "",
      },
      index1: "",
      ffModal: {
        unit: "",
        terms: "Collect",
        containerTypeId: "",
        mainEnquiryId: "",
        ffQId: "",
        enquiryClientId: "",
        ffType: "",
        ledgerId: "",
        buyingRate: "",
        ffSellingRate: "",
        shippingId: "",
        enquiryClientId: "",
        ffStatus: "",
        ffClientStatus: "",
        currency: "",
        line_wise_remark: "",
        MainEnquiryQuotationFFCreated: "",
        MainEnquiryQuotationFFUpdated: "",
      },
      mainModal: {
        quotationTill: "",
        mainffId: "",
        mainEnquiryId: "",
        mainFFSeries: "",
        ffClientStatus: "",
        ffStatusManager: "",
        ffvalidityDate: "",
        ffExpireStatus: "",
        transitTime: "",
        quotation_remark: "",
      },
      shipModal: {
        ffShippingWiseId: "",
        mainEnquiryId: "",
        ffQId: "",
        ffStatus: "",
        ffClientStatus: "",
        shippingId: "",
        transitTime: "",
        airlineId: "",
        creationTime: "",
        updateTime: "",
      },
      ccModal: {
        mainEnquiryId: "",
        enquiryClientId: "",
        ccQId: "",
        ccType: "",
        ccSellingRate: "",
        ccStatus: "",
      },
      containerTypeList: [],

      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],
      qTillList: [
        {
          qV: "1",
          qT: "Validity till Handover",
        },
        {
          qV: "2",
          qT: "Validity till Sailing",
        },
      ],
      statusList: [
        {
          statusV: "1",
          statusT: "Approve",
        },
        {
          statusV: "2",
          statusT: "Reject",
        },
      ],

      ENQHODMAIL: [],
      ledgerData: [],
      airLineData: [],
      checkModule: [],
      enquiryArry: [],
      ffShipArry: [],
      coloaderData: [],
      ffTableArry: [],
      tempffTableArry: [],
      sortConArry: [],
      tableMainData: [],
      ffMailData: [],
      ccTableArry: [],
      shippingList: [],
      mainFFtableIdForFF: "",
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },

  computed: {
    buttonDisable() {
      return this.mainModal.sendHODApproveFF == "1" ? false : true;
    },
  },
  watch: {
    shipModal: {
      handler: function (newVal, oldVal) {
        if (this.shipModal.shippingId != "" && this.shipModal.ffShippingWiseId == "") {
          let arrayDum = this.ffShipArry.filter((x) => {
            return x.shippingId == this.shipModal.shippingId;
          });

          if (arrayDum.length > 0) {
            if (this.shipmentType == 1) {
              this.alert.content = arrayDum[0].shippingLine + " Already Exists";
            } else {
              this.alert.content = arrayDum[0].airlineName + " Already Exists";
            }
            this.$refs["addPopAlready"].open();
            this.shipModal.shippingId = "";

            return false;
          }
        }
      },

      deep: true,
    },
  },

  methods: {
    getBookingList() {
      const options2 = {
        CBooking: "SalesExecutionCB",
        dataType: "CBList",
        checkAllCBVal: this.checkAllCBVal,
        allModuleId:
          this.$sessionsStorage.get("editSalesExId") || "", // simplified check
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") || "",
        loginId: this.$sessionsStorage.get("loginId"),
      };
      let self = this;

      getConsoleBooking(options2, function (error, result) {
        if (error) {
          console.error("Error fetching Console Booking:", error);
        } else {
          if (data.list) {
            this.ConsoleBookingList = data.list;
            console.log("Console Booking List size:", data.list.length);
          } else {
            this.ConsoleBookingList =[];
            this.ConsoleBookingListMSG = data.message;
          }
        }
      });
      
    },
    getPartiName() {
      let Arry = this.ledgerData.filter((x) => {
        return x.ledgerId == this.ffModal.ledgerId;
      });
      if (Arry.length > 0) {
        this.ffModal.ffType = Arry[0].ledger;
      } else {
        this.ffModal.ffType = "";
      }
    },
    visibleMFFFalse() {
      this.shipModal.shippingId = "";
      this.visibleMFF = false;
      this.getData();
    },
    visibleMFFTrue() {
      this.ffTableArry = [];
      this.visibleMFF = true;
    },
    Print(item) {
      if(!item) return;
      this.openSignedDocument(`FF_QUOTATION_PDF/${item}`);
    },
    sendMailEnq() {
      let list = [];
      let list2 = [];

      this.tempffTableArry.map((x) => {
        let i = list.indexOf(x.ffType + x.containerType);
        if (i < 0) {
          list.push(x.ffType + "<br>" + x.containerType);
        }
      });

      let unique = list.filter((item, i, ar) => ar.indexOf(item) === i);

      let newList = [];

      unique.map((x) => {
        let obj = {
          type: x,
        };
        console.log(x, obj);

        this.ffShipArry.map((y, index) => {
          let array1 = this.tempffTableArry.filter((z) => {
            return (
              z.ffShippingWiseId == y.ffShippingWiseId &&
              z.ffType + "<br>" + z.containerType == x
            );
          });

          if (array1.length > 0) {
            obj["s" + (index + 1)] = array1[0].ffSellingRate;
            obj["b" + (index + 1)] = array1[0].buyingRate;
            obj["conType"] = array1[0].containerType;
            obj["currency" + (index + 1)] = array1[0].currency;
          } else {
            obj["s" + (index + 1)] = "-";
            obj["b" + (index + 1)] = "-";
            obj["conType"] = "";
            obj["currency" + (index + 1)] = "";
          }
        });

        newList.push(obj);
      });
      if (this.shipmentType == "1") {
        for (let p = 0; p < this.containerTypeList.length; p++) {
          let arrySort1 = newList.filter((x) => {
            return x.type.split("<br>")[1] == this.containerTypeList[p].containerType;
          });

          if (arrySort1.length > 0) {
            list2.splice(p, 0, arrySort1);
          } else {
            console.log("container not in Quote");
          }
        }
      }
      this.newData["jobType"] = "FF";
      this.newData["MainFFtable"] = this.tempffTableArry;
      this.newData["table"] = list2;
      this.newData["MainFFShip"] = this.ffShipArry;
      this.isLoading = true;

      if (this.validate != false) {
        // $("#addButtonLoaderS").css("display", "none");
        // $("#loaderS").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/sendForClientTPT_VP.php`,
          data: JSON.stringify(this.newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            // $("#loaderS").css("display", "none");
            // $("#addButtonLoaderS").css("display", "block");

            this.isLoading = false;

            // this.getData();

            // this.$router.push({
            //   path: "/mainEnquiry/viewMainEnqQuotationTPT"
            // });
          })
          .catch((error) => {});
      }
    },
    getMainFFId(MAINFFID) {
      this.mainFFtableIdForFF = MAINFFID;

      this.getData();
      this.collapseFFChildVisible = true;
    },
    //deleteTPT(item) {
    //  let paylod = {
    //    tableName: "mainffquotation",
    //    tableId: "ffQId",
    //    tableVal: item.ffQId,
    //  };

    //  let options = {
    //    method: "POST",
    //    url: `${URL_BASE}/Enquiry/deletePermanent.php`,
    //    data: JSON.stringify(paylod),
    //    crossDomain: true,
    //    headers: {
    //      Accept: "application/json",
    //      "Content-Type": "application/json",
    //      Authorization: this.$sessionsStorage.get("loginId"),
    //    },
    //  };
    //  axios(options)
    //    .then((result) => {
    //      const { statusText, status, data } = result;
    //      if ( status == 200 && data) {
    //        this.getData();
    //      }
    //    })
    //    .catch((error) => {});
    //},

    deleteTPT(item) {
      this.itemObj = item;
      this.itemObj.isFFActive = item.isFFActive == "1" ? 0 : 1;
      let payload = {
        tableName: "mainffquotation",
        tableId: "ffQId",
        tableIsActive: "isFFActive",
        value1: this.itemObj.isFFActive,
        tableVal: item.ffQId,
        isMailSend: "No",
        manual: "No",
      };
      //console.log("Payload => ", payload); return false;
      ClientUserService.getAllActive(JSON.stringify(payload))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {
          console.log("Catch on getAllActive Error: ", error);
        });
    },
    openPop() {
      if (this.mainModal.ffvalidityDate == "") {
        return false;
      }
      if (this.shipmentType == "1") {
        let sameCon = [];
        this.ffShipArry.map((p) => {
          this.containerTypeList.map((x) => {
            sameCon = this.tempffTableArry.filter((y) => {
              return (p.shippingId =
                y.shippingId &&
                y.containerTypeId == x.containerTypeId &&
                y.containerType == x.containerType);
            });
          });
        });

        if (sameCon.length != this.containerTypeList.length) {
          // this.confirm.contentHtml =
          //   "<h5 class='error'>INCOMPLETE QUOTE</h5>All Containers Type Requested are not added yet in this Quotation.<br> Send Incomplete Quote for Approval..?";
          this.confirm.contentHtml =
            "Send Quote for Approval..? <br> <strong>Data cannot be updated onces Sent For Approval.</strong>";
        } else {
          this.confirm.contentHtml =
            "Send  Quote for Approval..? <br> <strong>Data cannot be updated onces Sent For Approval.</strong>";
        }
      } else {
        this.confirm.contentHtml =
          "Send  Quote for Approval..? <br> <strong>Data cannot be updated onces Sent For Approval.</strong>";
      }

      this.$refs["popMail"].open();
    },
    sendMail(type) {
      if (type != "cancel") {
        if (this.shipmentType == "1") {
          this.tempffTableArry = [];

          for (let s = 0; s < this.containerTypeList.length; s++) {
            let arrySort = this.sortConArry.filter((x) => {
              return x.containerType == this.containerTypeList[s].containerType;
            });

            if (arrySort.length > 0) {
              this.tempffTableArry.push(...arrySort);
            } else {
              console.log("container not in Quote");
            }
          }
        }

        this.isLoading = true;
        let list = [];
        let list2 = [];

        this.tempffTableArry.map((x) => {
          let i = list.indexOf(x.ffType + x.containerType);
          if (i < 0) {
            list.push(x.ffType + "<br>" + x.containerType);
          }
        });

        let unique = list.filter((item, i, ar) => ar.indexOf(item) === i);

        let newList = [];
        unique.map((x) => {
          let obj = {
            type: x,
          };
          console.log(x, obj);
          this.ffShipArry.map((y, index) => {
            let array1 = this.tempffTableArry.filter((z) => {
              return (
                z.ffShippingWiseId == y.ffShippingWiseId &&
                z.ffType + "<br>" + z.containerType == x
              );
            });

            if (array1.length > 0) {
              obj["s" + (index + 1)] = array1[0].ffSellingRate;
              obj["b" + (index + 1)] = array1[0].buyingRate;
              obj["conType"] = array1[0].containerType;
              obj["currency" + (index + 1)] = array1[0].currency;
            } else {
              obj["s" + (index + 1)] = "-";
              obj["b" + (index + 1)] = "-";
              obj["conType"] = "";
              obj["currency" + (index + 1)] = "";
            }
          });

          newList.push(obj);
        });

        if (this.shipmentType == "1") {
          for (let p = 0; p < this.containerTypeList.length; p++) {
            let arrySort1 = newList.filter((x) => {
              return x.type.split("<br>")[1] == this.containerTypeList[p].containerType;
            });

            if (arrySort1.length > 0) {
              list2.splice(p, 0, arrySort1);
            } else {
              console.log("container not in Quote");
            }
          }
        } else {
          list2 = newList;
        }
        console.log(list2);
        let newData = {
          mainffId: this.mainFFtableIdForFF,
          mainEnquiryId: this.$sessionsStorage.get("editMainEnqId"),
          mainFFSeries: this.mainModal.mainFFSeries,
          jobType: "FF",
          MainFFQ: this.ffMailData[0],
          MainFFShip: this.ffShipArry,
          validityDate: this.mainModal.ffvalidityDate,
          quotationTill: this.mainModal.quotationTill,
          MainFFtable: this.tempffTableArry,
          MainEnq: this.enquiryArry[0],
          table: list2,
          hodMails: this.ENQHODMAIL,
        };
        console.log(newData);
        // return false;

        if (this.validate != false) {
          $("#addButtonLoaderS").css("display", "none");
          $("#loaderS").css("display", "block");

          let options = {
            method: "POST",
            url: `${URL_BASE}/Enquiry/sendForApprovalTPT_VP.php`,
            data: JSON.stringify(newData),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");
              this.isLoading = false;
              this.alert.content = "Mail Sent";
              this.$refs["popMailAfter"].open();
              this.getData();
              // this.$router.push({
              //   path: "/mainEnquiry/viewMainEnqQuotationFF"
              // });
            })
            .catch((error) => {});
        }
      }
    },
    clearShip() {
      Object.keys(this.shipModal).map((x) => {
        this.shipModal[x] = "";
      });
      Object.keys(this.ffModal).map((x) => {
        this.ffModal[x] = "";
      });
      this.ffTableArry = [];
    },
    openTPT() {
      this.openTPTDiv = true;
    },
    openFF() {
      this.openFFDiv = true;
    },
    openCC() {
      this.openCCDiv = true;
    },

    finalbasecost() {
      let driverExpensenew =
        parseFloat(this.tptModal.driverExp) * parseFloat(this.tptModal.travelDur);

      let averageTrucknew =
        parseFloat(this.tptModal.distance) / parseFloat(this.tptModal.mileage);

      let dieselRatenew =
        parseFloat(averageTrucknew) * parseFloat(this.tptModal.dieselRate);
      let basefinalcost =
        parseFloat(dieselRatenew) +
        parseFloat(driverExpensenew) +
        parseFloat(this.tptModal.toll);
      this.tptModal.baseCost = basefinalcost.toFixed(2);

      let finalSalesCost =
        (parseFloat(this.tptModal.baseCost) * parseFloat(this.tptModal.margin)) / 100;
      let finalSalesCost2 = finalSalesCost + parseFloat(this.tptModal.baseCost);
      this.tptModal.quotRate = finalSalesCost2.toFixed(2);
    },
    validateTPTQuotation(ID) {
      let validateNew = true;

      if (ID == "2") {
        if (this.ffModal.ledgerId == "") {
          this.blankffStatusError = "Select particulars";
          validateNew = false;
        } else {
          this.blankffStatusError = "";
        }
        if (this.ffModal.containerTypeId == "" && this.shipmentType == "1") {
          this.blankConTypeError = " Select Container Type";
          validateNew = false;
        } else {
          this.blankConTypeError = "";
        }
        if (this.particularStatus == "0") {
          if (this.ffModal.buyingRate == "") {
            this.blankbuyinError = "Enter Buying Rate";
            validateNew = false;
          } else {
            this.blankbuyinError = "";
          }
          if (this.ffModal.ffSellingRate == "") {
            this.blankSellingError = "Enter Selling Rate";
            validateNew = false;
          } else {
            this.blankSellingError = "";
          }
          if (this.ffModal.currency == "") {
            this.blankcurrencyError = " Select Currency";
            validateNew = false;
          } else {
            this.blankcurrencyError = "";
          }
        }
      }

      if (validateNew) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addGenerateQuotation(ID) {
      if (this.mainModal.ffvalidityDate == "" || this.mainModal.ffvalidityDate == null) {
        this.alert.content = " Please Selet Quote Validity Date ";
        this.$refs["addPopAlready"].open();
        return false;
      }

      if (ID == "2") {
        this.validateTPTQuotation(ID);
        if (this.shipModal.shippingId == "") {
          if (this.shipmentType == 1) {
            this.alert.content = "Please Select Shipping line";
          } else {
            this.alert.content = " Please Select Airline ";
          }

          this.$refs["addPopAlready"].open();
          return false;
        }
        if (this.shipModal.shippingId != "" && this.shipModal.ffShippingWiseId == "") {
          let arrayDum = this.ffShipArry.filter((x) => {
            return x.shippingId == this.shipModal.shippingId;
          });

          if (arrayDum.length > 0) {
            if (this.shipmentType == 1) {
              this.alert.content = arrayDum[0].shippingLine + " Already Exists";
            } else {
              this.alert.content = arrayDum[0].airlineName + " Already Exists";
            }
            this.$refs["addPopAlready"].open();
            this.shipModal.shippingId = "";

            return false;
          }
        }
      }

      if (this.particularStatus == 1) {
        this.ffModal.buyingRate = "Charges As Per Receipt";
        this.ffModal.ffSellingRate = "Charges As Per Receipt";
        this.ffModal.currency = "";
      }

      this.mainModal["mainEnquiryId"] = this.$sessionsStorage.get("editMainEnqId");
      this.mainModal["mainffId"] = this.mainFFtableIdForFF;
      this.shipModal["mainEnquiryId"] = this.$sessionsStorage.get("editMainEnqId");
      this.shipModal["mainffId"] = this.mainFFtableIdForFF;
      this.ffModal["mainEnquiryId"] = this.$sessionsStorage.get("editMainEnqId");
      this.ffModal["mainffId"] = this.mainFFtableIdForFF;

      let newData = {
        FFModal: this.ffModal,
        mainModal: this.mainModal,
        shipModal: this.shipModal,
        buttonId: ID,
      };
      console.log(newData);
      // return false;

      if (this.validate != false) {
        if (ID == "2") {
          $("#addButtonLoader1").css("display", "none");
          $("#loader1").css("display", "block");
        }
        if (ID == "5") {
          $("#addButtonLoaderM").css("display", "none");
          $("#loaderM").css("display", "block");
        }

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addMainFFQuotation.php`,
          data: JSON.stringify(newData),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            if (ID == "2") {
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");
            }

            if (ID == "5") {
              $("#loaderM").css("display", "none");
              $("#addButtonLoaderM").css("display", "block");
              this.getData();
            }
            if (this.mainFFtableIdForFF == "") {
              this.mainFFtableIdForFF = data.mainffId;
              this.shipModal.ffShippingWiseId = data.dataQuotation[0].ffShippingWiseId;
            }

            if (this.ffModal.ffQId == "") {
              this.ffTableArry.push(data.dataQuotation[0]);
            } else {
              this.ffTableArry[this.index1] = this.ffModal;
            }

            this.ffModal.buyingRate = "";
            this.ffModal.ffSellingRate = "";
            this.ffModal.ffType = "";
            this.ffModal.line_wise_remark = "";
            this.ffModal.ledgerId = "";
            this.ffModal.ffQId = "";

            this.ffModal.MainEnquiryQuotationFFCreated = "";
            this.ffModal.MainEnquiryQuotationFFUpdated = "";

            this.particularStatus = "0";

            // if (this.shipModal.ffShippingWiseId == "") {
            //   Object.keys(this.shipModal).map(x => {
            //     this.shipModal[x] = "";
            //   });
            //   Object.keys(this.ffModal).map(x => {
            //     this.ffModal[x] = "";
            //   });
            // }
            this.getData();
            this.getData(data.dataQuotation[0].ffShippingWiseId);
          })
          .catch((error) => {});
      }
    },
    previousFFView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/mainEnquiry/viewMainEnqQuotationFF"
      // });
    },

    JqueryFun() {
      return $(function () {
        $("#tpt").DataTable();

        $("#cc").DataTable();
      });
    },

    editShip(ID) {
      console.log(ID);
      Object.keys(this.shipModal).map((x) => {
        this.shipModal[x] = ID[x];
      });
      let array = this.tempffTableArry.filter((x) => {
        return x.ffShippingWiseId == ID.ffShippingWiseId;
      });

      if (array.length > 0) {
        this.ffTableArry = array;
      } else {
        this.ffTableArry = [];
      }
      this.visibleMFF = true;
    },
    editFF(item, index) {
      Object.keys(this.ffModal).map((x) => {
        this.ffModal[x] = item[x];
      });
      this.index1 = index;
      // this.openFFDiv = true;
    },

    getData(sId) {
      this.tempffTableArry = [];
      this.isLoading = true;
      let payload = {
        assignmentNo: "assignmentNo",
        fetchFor: "FF",
        mainEnquiryId:
          this.$sessionsStorage.get("editMainEnqId") != "" ||
          this.$sessionsStorage.get("editMainEnqId") != undefined
            ? this.$sessionsStorage.get("editMainEnqId")
            : "",

        mainffId:
          this.mainFFtableIdForFF != "" || this.mainFFtableIdForFF != undefined
            ? this.mainFFtableIdForFF
            : "",
        ffShippingWiseId:
          this.$sessionsStorage.get("editffShipId") != "" ||
          this.$sessionsStorage.get("editffShipId") != undefined
            ? this.$sessionsStorage.get("editffShipId")
            : "",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/getDataMainQuot.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (data.enquiryData.length > 0) {
              this.enquiryArry = data.enquiryData;
              this.noOfPkg = data.enquiryData[0].noOfPkg;
              this.volWgt = data.enquiryData[0].grossVolWgtAir;
              this.grsWgt = data.enquiryData[0].lclGrossWgt;
              this.netWgt = data.enquiryData[0].lclNetWgt;
              this.dimension = data.enquiryData[0].selectedDimmen;
              this.remarks = data.enquiryData[0].remark;
              this.checkModule = data.enquiryData[0].jobType.split(",");
              this.shipmentType = data.enquiryData[0].shipmentType;
              this.fclOrlcl = data.enquiryData[0].containerInfo;
            } else {
              this.enquiryArry = [];
            }

            if (data.ledgerData.length > 0) {
              this.ledgerData = data.ledgerData;
            } else {
              this.ledgerData = [];
            }

            if (data.unitList.length > 0) {
              this.unitList = data.unitList;
            } else {
              this.unitList = [];
            }
            if (data.airLineData.length > 0) {
              this.airLineData = data.airLineData;
            } else {
              this.airLineData = [];
            }

            if (data.ENQHODMAIL.length > 0) {
              this.ENQHODMAIL = data.ENQHODMAIL;
            } else {
              this.ENQHODMAIL = [];
            }

            if (data.containerMaster.length > 0) {
              for (let q = 0; q < data.containerMaster.length; q++) {
                if (data.containerMaster[q].containerTypeId == "16") {
                  data.containerMaster[q].containerType = "20" + "'" + " STD";
                  data.containerMaster[q].containerTypeId = "1";
                }
              }
              this.containerTypeList = data.containerMaster;
            } else {
              this.containerTypeList = [];
            }

            if (data.ffShipData.length > 0) {
              this.ffShipArry = data.ffShipData;
            } else {
              this.ffShipArry = [];
            }

            if (data.coloaderData.length > 0) {
              this.coloaderData = data.coloaderData;
            } else {
              this.coloaderData = [];
            }
            if (data.fflastData.length > 0) {
              this.tempffTableArry = data.fflastData;
              
              this.ffModal.MainEnquiryQuotationFFCreated=data.fflastData[0].MainEnquiryQuotationFFCreated;
              this.ffModal.MainEnquiryQuotationFFUpdated=data.fflastData[0].MainEnquiryQuotationFFUpdated;
              console.log(this.tempffTableArry, "uuuu");
              if (this.shipmentType == "1") {
                this.tempffTableArry = [];
                this.sortConArry = data.fflastData;

                for (let s = 0; s < this.containerTypeList.length; s++) {
                  let arrySort = this.sortConArry.filter((x) => {
                    return x.containerType == this.containerTypeList[s].containerType;
                  });

                  if (arrySort.length > 0) {
                    this.tempffTableArry.push(...arrySort);
                  } else {
                    console.log("container not in Quote");
                  }
                }
              }
              if (sId != "" && sId != undefined && sId != null) {
                let array = this.tempffTableArry.filter((x) => {
                  return x.ffShippingWiseId == sId;
                });

                if (array.length > 0) {
                  this.ffTableArry = array;
                } else {
                  this.ffTableArry = [];
                }
              } else {
                this.ffTableArry[this.index1] = this.ffModal;
              }
            }
            if (data.fflastDataStatus.length > 0) {
              this.ffMailData = data.fflastDataStatus;
              Object.keys(data.fflastDataStatus[0]).map((x) => {
                this.mainModal[x] = data.fflastDataStatus[0][x] || "";
              });

              this.mainModal.ffClientStatus = data.fflastDataStatus[0].ffClientStatus;
            }

            if (data.slineDetails.length > 0) {
              this.shippingList = data.slineDetails;
            }
            if (data.ffData.length > 0) {
              this.tableMainData = data.ffData;

              this.collapseFFMainVisible = true;

              let arryStatus = data.ffData.filter((x) => {
                return (
                  x.ffStatusManager == "1" &&
                  x.ffClientStatus != "2" &&
                  x.sendToEnquiryFF != "1"
                );
              });

              if (arryStatus.length > 0) {
                this.newData.mainffId = arryStatus[0].mainffId;
                this.newData.mainEnquiryId = arryStatus[0].mainEnquiryId;
                this.newData.mainFFSeries = arryStatus[0].mainFFSeries;
                this.newData.ffQuotationPdf = arryStatus[0].ffQuotationPdf;

                this.sendMailEnq();
              }

              // if (data.ffData.length == 1) {
              //   this.mainFFtableIdForFF = data.ffData[0].mainffId;
              // }

              // let arryStatus = this.ffTableArry.filter(x => {
              //   return x.ffClientStatus == "1";
              // });

              // if (arryStatus.length > 0) {
              //   // this.hideButtn = true;
              // }

              // let arryExpire = this.ffTableArry.filter(x => {
              //   return x.ffExpireStatus == "0" && x.ffClientStatus == "2";
              // });

              // if (arryExpire.length > 0) {

              //   this.hideButtn = false;
              // }
            } else {
              this.tableMainData = [];

              this.collapseFFChildVisible = true;
              this.visibleMFF = true;
            }
            this.isLoading = false;
            let filteredSline = this.tempffTableArry.filter((p) => {
              return p.shippingId == this.shipModal.shippingId;
            });
            if (filteredSline.length > 0) {
              this.ffTableArry = filteredSline;
            }

            console.log(this.tempffTableArry, "3333", this.ffTableArry);
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    // By Priyanshu Singh 24/12/2021 Start
    dateDifference(pre_validityDate, current_date) {
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010

      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    currentDate() {
      var currentDate = new Date();
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      return currentDateWithFormat;
    },
    convert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    },
    dateRestriction(pre_validityDate) {
      const today = new Date(pre_validityDate);
      const minDate = new Date(today);
      // minDate.setMonth(minDate.getMonth()); // one Months
      // minDate.setDate(dateNo);
      const maxDate = new Date(today);
      // maxDate.setMonth(maxDate.getMonth() + 1); // one Months
      this.min = minDate;
      // this.max = maxDate;
      // alert(getDate);
      // alert(minDate);
      // alert(maxDate);
    },
    QutationValidityhide(pre_validityDate, isHidden) {
      this.dateRestriction(pre_validityDate);
      $("#QutationValidityhide_err").text("");
      let current_date = this.currentDate();
      // current_date = '2022-08-04';
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010
      let days_count = 0;
      if (date2 >= date1) {
        days_count = this.dateDifference(pre_validityDate, current_date);
      } else {
        days_count = 0;
      }
      // alert(days_count);
      // let days_count = 46;
      if (
        this.$sessionsStorage.get("designation") != "Admin" &&
        this.$sessionsStorage.get("nameUser") != "Bhavneesh"
      ) {
        if (days_count > 45) {
          this.isHidden = true;
          this.errorModal.validityDate =
            "Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed";
          $("#QutationValidityhide_err").text(
            "Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed"
          );
          // console.log("Sorry Your Qutation Validity Extends after(45 Days also Expire) You are not allowed");
        } else {
          if (isHidden == false) {
            this.isHidden = true;
          } else if (isHidden == true) {
            this.isHidden = false;
          } else {
            this.isHidden = false;
          }
        }
      } else {
        if (isHidden == false) {
          this.isHidden = true;
        } else if (isHidden == true) {
          this.isHidden = false;
        } else {
          this.isHidden = false;
        }
      }
    },
    updateValidityDate(ffvalidityDate, mainffId, maintptId, quot_type, pre_validityDate) {
      console.log("ffvalidityDate=>", ffvalidityDate);
      console.log("mainffId=>", mainffId);
      console.log("maintptId=>", maintptId);
      console.log("quot_type=>", quot_type);
      console.log("pre_validityDate=>", pre_validityDate);
      let current_date = this.currentDate();
      let days_count = this.dateDifference(pre_validityDate, current_date);
      Object.keys(this.errorModal).map((x) => {
        if (this.ffModal[x] == "") {
          this.errorModal[x] = this.arrayErrorModal[x] || "";
          validateNew = false;
        } else {
          this.errorModal[x] = "";
        }
      });
      if (this.validateNew != false) {
        let paylod = {
          tableName: "mainffquosales",
          fk_quot_id: mainffId, //this.$sessionsStorage.get("editTPTQId") maintptId this.ffModal.tptQId
          fk_mainEnquiryId: this.$sessionsStorage.get("editMainEnqId"),
          validityDate: this.convert(ffvalidityDate),
          quot_type: quot_type,
          pre_validityDate: pre_validityDate,
        };
        // console.log(paylod);
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/AddValidityDateTrack.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            console.log(result);
            console.log("priyanshu");
            if (status == 200 && data) {
              if (data.status == false) {
                $("#QutationValidityhide_err").text(data.msg);
              } else if (data.status == true) {
                this.QutationValidityhide(this.convert(ffvalidityDate), false);
                this.getData();
              }
            } else if (status && data) {
            }
          })
          .catch((error) => {});
      }
    },
    calculateMinDate() {
      const currentDate = new Date();
      // Set the minimum date to tomorrow
      currentDate.setDate(currentDate.getDate());
      return currentDate.toISOString().split("T")[0];
    },
    calculateMaxDate() {
      // Set the maximum date to a future date if needed
      const maxDate = new Date();
      maxDate.setDate(maxDate.getDate() + 60); // Adjust the number of days as needed
      return maxDate.toISOString().split("T")[0];
    },
    // By Priyanshu Singh 24/12/2021 End
  },
};
</script>
<style>
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .mobile-table {
    height: 350px !important;
  }
}
</style>



// WEBPACK FOOTER //
// mainEnqQuotationFF.vue?64cec08c